module.exports = __webpack_public_path__ + "img/devices.3bfd93f7.png";